/**
 * Описания хранятся в markdown с собственными тегами ({@item id, Название}, [indent]…[/indent]).
 * Для мета-тегов из них нужен голый текст.
 */
export function stripMarkup(text?: string | null): string {
	if (!text) return '';
	return text
		.replace(/\{@\w+\s+([^}]*)\}/g, (_, inner: string) => {
			const args = inner.split(',');
			return (args.length > 1 ? args.slice(1).join(',') : args[0]).trim();
		})
		.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
		.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
		// теги книги идут и с атрибутами: [inset id="…"], [img src="…" /], [table caption="…"]
		.replace(/\[\/?[a-z]+(?:[=\s][^\]]*)?\]/gi, ' ')
		.replace(/<[^>]+>/g, ' ')
		.replace(/^\s*\|.*$/gm, ' ')
		.replace(/^\s*#{1,6}\s+/gm, '')
		.replace(/^\s*(?:[-*+]|\d+\.|>)\s+/gm, '')
		.replace(/(\*\*|\*|~~|`|_)/g, '')
		.replace(/\s+/g, ' ')
		.trim();
}

/** Обрезает по границе слова, не длиннее max символов */
export function truncate(text: string, max: number): string {
	if (text.length <= max) return text;
	const cut = text.slice(0, max - 1);
	const space = cut.lastIndexOf(' ');
	return `${(space > max * 0.6 ? cut.slice(0, space) : cut).replace(/[\s,;:.—-]+$/, '')}…`;
}

/** Первые целые предложения, укладывающиеся в max символов */
export function firstSentences(text: string, max: number): string {
	const sentences = text.match(/[^.!?…]+[.!?…]+(?=\s|$)|[^.!?…]+$/g) || [];
	let result = '';
	for (const sentence of sentences) {
		const next = `${result} ${sentence.trim()}`.trim();
		if (next.length > max) break;
		result = next;
	}
	return result || truncate(text, max);
}

/** Ориентир для meta description: поисковики показывают 160–250 символов */
export const DESCRIPTION_MAX = 250;

function withPeriod(text: string): string {
	return !text || /[.!?…]$/.test(text) ? text : `${text}.`;
}

/** Сгенерированная из метаданных фраза плюс начало текста, если осталось место */
export function composeDescription(lead: string, text?: string | null, max = DESCRIPTION_MAX): string {
	const cleanLead = withPeriod(lead.replace(/\s+/g, ' ').trim());
	if (cleanLead.length >= max) return truncate(cleanLead, max);
	const rest = stripMarkup(text);
	const room = max - cleanLead.length - 1;
	if (!rest || room < 40) return cleanLead;
	return withPeriod(`${cleanLead} ${firstSentences(rest, room)}`.trim());
}
